import backend, {LOOM_API} from 'utils/backend/loom/api_library';

const loomApi = () => {
  if (!LOOM_API) {
    throw new Error('REACT_APP_LOOM_API must be configured before Loom family member writes can be enabled.');
  }

  return LOOM_API.replace(/\/$/, '');
};

const familyMembersPath = (clientId) => {
  return `${loomApi()}/api/careos/clients/${encodeURIComponent(clientId)}/family-members`;
};

const addFamilyMember = (clientId, body) => {
  return backend.post(familyMembersPath(clientId), body);
};

const updateFamilyMember = (clientId, familyMemberId, body) => {
  return backend.post(`${familyMembersPath(clientId)}/${encodeURIComponent(familyMemberId)}/update`, body);
};

const removeFamilyMember = (clientId, familyMemberId) => {
  return backend.post(`${familyMembersPath(clientId)}/${encodeURIComponent(familyMemberId)}/archive`);
};

const renameFamily = (clientId, body) => {
  return backend.post(`${loomApi()}/api/careos/clients/${encodeURIComponent(clientId)}/family/update`, body);
};

const updateFamilyNotes = (clientId, body) => {
  return backend.post(`${loomApi()}/api/careos/clients/${encodeURIComponent(clientId)}/family/notes/update`, body);
};

const updateClientNotes = (clientId, body) => {
  return backend.post(`${loomApi()}/api/careos/clients/${encodeURIComponent(clientId)}/notes/update`, body);
};

export default {
  addFamilyMember,
  updateFamilyMember,
  removeFamilyMember,
  renameFamily,
  updateFamilyNotes,
  updateClientNotes,
};
